import { DoublePayments } from 'shared/components/double-payments'
import { PartnerRegisters } from 'shared/components/partner-registers/PartnerRegisters'
import { ShiftDifferences } from 'shared/components/shift-differences'

/**
 * The support section's pages that show a shared screen as it is (spec §19, §26):
 * every Point's double payments that the Shift did not resolve (ADR-0046), the Shift
 * differences (ADR-0035) and the partners' Registers (ADR-0036, ticket 16) — support
 * reads them and adds cancellation lines, never builds or pays one.
 */
export function SupportDoublePayments() {
	return <DoublePayments forSupport />
}

export function SupportShiftDifferences() {
	return <ShiftDifferences />
}

export function SupportRegisters() {
	return <PartnerRegisters />
}
